import { ServiceVisitReportFileType } from "../Models";

export const SITE_TREE: string = "sites";
export const LOCATIONS_TREE: string = "locations";

export const SITE_WITH_PARENTS: string = "siteWithParents";
export const BUILDS_TREE: string = "assets";
export const CUSTOMERS_TREE: string = "customers";
export const PRODUCTS_TREE: string = "products";

export const TYPE_COUNTRY: string = "country";
export const TYPE_SITE: string = "Site";
export const TYPE_SITE360: string = "Site360";
export const TYPE_PLANT: string = "Plant";
export const TYPE_PLANTUNIT: string = "Plant Unit";
export const TYPE_EQUIPMENT: string = "Equipment";
export const TYPE_BUILD: string = "Build";
export const TYPE_COMPONENT: string = "Component";
export const TYPE_MODULE: string = "Module";
export const TYPE_CUSTOMERS: string = "customers";
export const TYPE_CAPEX: string = "Capex";
export const TYPE_PRODUCT_GROUP: string = "Product Group";
export const TYPE_PRODUCT_FAMILY: string = "Product Family";
export const TYPE_PRODUCT_SERIES: string = "Product Series";
export const TYPE_SELLABLE_PRODUCT_MODEL: string = "Sellable Product Model";
export const TYPE_SERVICE: string = "Service";
export const TYPE_EQUIPMENT_PRODUCT: string = "Equipment Product";
export const TYPE_SERVICE_PRODUCT: string = "Service Product";
export const TYPE_EQUIPMENT_MODEL_REVISION: string = "Equipment Model Revision";
export const TYPE_SERVICE_MODEL_REVISION: string = "Service Model Revision";
export const TYPE_PLANT_PRODUCT: string = "Plant Product";
export const TYPE_MODEL: string = "Model";
export const TYPE_MODEL_REVISION: string = "Model Revision";
export const TYPE_PRODUCT: string = "Product";
export const TYPE_PROCESS_PRODUCT: string = "Process Product";
export const TYPE_SYSTEM_PRODUCT: string = "System Product";
export const TYPE_PROCESS_MODEL_REVISION: string = "Process Model Revision";
export const TYPE_SYSTEM_MODEL_REVISION: string = "System Model Revision";
export const TYPE_PLANT_PRODUCT_INSTANCE: string = "Plant Product Instance";

export const OPEN_SIBLINGS: string = "expand";
export const CLOSE_SIBLINGS: string = "collapse";

export const LINK_TO_INTERNAL_PAGE: string = "internal";
export const LINK_TO_EXTERNAL_PAGE: string = "external";
export const LINK_TO_SAS: string = "sas";
export const LINK_TO_LOCAL: string = "local";
export const LINK_TO_POWERBI: string = "powerbi";
export const LINK_TO_CRM_CUSTOMER: string = "crmcustomer";
export const LINK_TO_CRM_OPPORTUNITY: string = "crmopportunity";
export const LINK_TO_CRM_SITE: string = "crmsite";
export const SEARCH: string = "search";

export const CHEVRON_RIGHT: string = "chevron-right";
export const CHEVRON_LEFT: string = "chevron-left";
export const CHEVRON_UP: string = "chevron-up";
export const CHEVRON_DOWN: string = "chevron-down";
export const DROPFILES: string = "dropfiles";

export const CIRCLE: string = "circle";
export const CLOSE: string = "close";
export const EDIT: string = "edit";
export const INFO: string = "info";
export const WARNING: string = "warning";
export const MENU: string = "menu";
export const REMOVE: string = "remove";

export const KEY_ENTER: number = 13;

export const INFO_ROUNDED: string = "inforounded";
export const SORT_UP: string = "sort-up";
export const SORT_DOWN: string = "sort-down";

export const OUTOTEC: string = "outotec-logo";

export const acceptedFileFormats: string = `application/pdf,
        text/csv,
        image/svg+xml,
        image/png,
        image/jpeg,
        application/vnd.ms-excel,
        application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
        application/msword,
        application/vnd.openxmlformats-officedocument.wordprocessingml.document,
        application/vnd.ms-powerpoint,
        application/vnd.openxmlformats-officedocument.presentationml.presentation`;

export const acceptedFileFormatsSimple: string =
  "pdf, csv, svg, png, jpeg, xls, xlt, xla, xlsx, doc, dot, docx, ppt, pt, pps, ppa, pptx";

export const DIVIDER: string = "DIVIDER";

export const DATETIME_FORMAT: string = "YYYY-MM-DD";
export const CALENDAR: string = "calendar";

export const SEARCH_RESULT_BUILDS: string = "builds";
export const SEARCH_RESULT_LOCATIONS: string = "locations";
export const SEARCH_RESULT_CUSTOMERS: string = "customers";
export const SEARCH_RESULT_PRODUCTS: string = "products";
export const SEARCH_RESULT_DOCUMENTS: string = "documents";

export const SEARCH_FILTER_GROUP_BUILD: string = "Build";
export const SEARCH_FILTER_GROUP_LOCATION: string = "Location";
export const SEARCH_FILTER_GROUP_CUSTOMER: string = "Customer";
export const SEARCH_FILTER_GROUP_PRODUCT: string = "Product";
export const SEARCH_FILTER_GROUP_DOCUMENT: string = "Document";

export const GENERAL_DETAILS_ATTRIBUTE_GROUP_NAME: string = "General Details";

export const DATA_GROUP_TYPE_PRODUCT_DATA: number = 2;

export const SOURCE_MIH: string = "Metso Information Hub";

export const POWERBI_REPORT_ID = "0b578485-6b84-4318-9453-f75c3c8f397a";

export const YAMMER_FEEDBACK_URL =
  "https://www.yammer.com/metso.com/#/threads/inGroup?type=in_group&feedId=33368940544&view=all";

export const FEEDBACK_URL_BUG_REPORT =
  "https://forms.office.com/Pages/ResponsePage.aspx?Host=Teams&lang=%7Blocale%7D&groupId=%7BgroupId%7D&tid=%7Btid%7D&teamsTheme=%7Btheme%7D&upn=%7Bupn%7D&id=9FZUXALExUCnPeeHd-e_nsZT07panrFKlIBaogPX_TtUM1VKS0YxWTFQVUI1VVpXS1hERVZOVjlVMiQlQCN0PWcu";

export const FEEDBACK_URL_FEATURE_REQUESTS =
  "https://forms.office.com/Pages/ResponsePage.aspx?Host=Teams&lang=%7Blocale%7D&groupId=%7BgroupId%7D&tid=%7Btid%7D&teamsTheme=%7Btheme%7D&upn=%7Bupn%7D&id=9FZUXALExUCnPeeHd-e_nsZT07panrFKlIBaogPX_TtUQkFBTFgwQk5OTEExTlVBUlc5S0FaQkNVMSQlQCN0PWcu";

export const FEEDBACK_URL_GENERAL_FEEDBACK =
  "https://forms.office.com/Pages/ResponsePage.aspx?Host=Teams&lang=%7Blocale%7D&groupId=%7BgroupId%7D&tid=%7Btid%7D&teamsTheme=%7Btheme%7D&upn=%7Bupn%7D&id=9FZUXALExUCnPeeHd-e_nsZT07panrFKlIBaogPX_TtUM1BQWjNPMTZEWlVJS0ZSQkdNWjkzVDlRVyQlQCN0PWcu";

export const SERVICE_VISIT_REPORT_FILE_TYPES = [
  {
    label: "Site Visit Report (Field Service)",
    value: "SiteVisitReportFieldService",
  },
  {
    label: "Site Visit Report (Technology Support)",
    value: "SiteVisitReportTechnologySupport",
  },
  {
    label: "Site Assessment / Audit (Technical)",
    value: "SiteAssessmentAuditTechnical",
  },
  {
    label: "Site Assessment / Audit (Process)",
    value: "SiteAssessmentAuditProcess",
  },
  {
    label: "Plant Performance Assessment",
    value: "PlantPerformanceAssessment",
  },
  // { this is not required
  //     label: "Inspection Report",
  //     value: "InspectionReport",
  // },
  {
    label: "Asset Walk Report",
    value: "AssetWalkReport",
  },
  {
    label: "IOMS manual",
    value: "IOMSManual",
  },
  {
    label: "Spare part list",
    value: "SparePartList",
  },
  {
    label: "Handover to MA checklist",
    value: "HandoverToMAChecklist",
  },
  {
    label: "GA drawing/P&ID",
    value: "GADrawing/P&ID",
  },
  {
    label: "Installation & Commissioning report",
    value: "InstallationCommissioningReport",
  },
  {
    label: "Technical Document",
    value: "TechnicalDocument",
  },
];
